import React, { useEffect, useState } from "react";
import styles from "./ProductDetails.module.css";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import Loader from "../../Loader/Loader";
import { useLocation, useNavigate } from "react-router";

import {
  productDetails,
  flagProduct,
  removeProduct,
} from "../../service/Mainservice";
import { Flag } from "@mui/icons-material";

const ProductDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState(null);

  const [selectedImage, setSelectedImage] = useState("");

  const [showFlagModal, setShowFlagModal] = useState(false);

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  const [flagReason, setFlagReason] = useState("");

  const [removeReason, setRemoveReason] = useState("");

  console.log(location);
  useEffect(() => {
    getProduct();
  });

  const getProduct = async () => {
    try {
      setLoading(true);
      const product = location.state?.item;

      setData(product);

      if (product.images && product.images.length > 0) {
        setSelectedImage(product.images[0].image);
      }

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  /* ============================
          FLAG PRODUCT
  ============================ */

  const handleFlagProduct = async () => {
    try {
      if (!flagReason.trim()) {
        alert("Please enter flag reason");
        return;
      }

      await flagProduct({
        productId: data.id,
        flagReason,
      });

      setShowFlagModal(false);

      setFlagReason("");

      getProduct();
    } catch (err) {
      console.log(err);
    }
  };

  /* ============================
          REMOVE PRODUCT
  ============================ */

  const handleRemoveProduct = async () => {
    try {
      if (!removeReason.trim()) {
        alert("Please enter remove reason");
        return;
      }

      await removeProduct({
        productId: data.id,
        reason: removeReason,
      });

      navigate(-1);
    } catch (err) {
      console.log(err);
    }
  };

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString();
  };

  if (loading) {
    return <Loader />;
  }

  if (!data) {
    return <div className={styles.emptyState}>Product not found.</div>;
  }

  return (
    <>
      <div className={styles.productDetailsPage}>
        {/* ================= HEADER ================= */}
        <div className="details_header">
          <button className="back_btn" onClick={() => navigate("/Products")}>
            ← Back to Products
          </button>
          <h2>Product Details</h2>
        </div>
        {/* ================= HERO ================= */}
        <div className={styles.heroSection}>
          {/* LEFT SIDE */}

          <div className={styles.imageSection}>
            <div className={styles.mainImage}>
              <img
                src={selectedImage || "/images/no-image.png"}
                alt={data.name}
                onError={(e) => {
                  e.target.src = "/images/no-image.png";
                }}
              />
            </div>

            {data.images?.length > 0 && (
              <div className={styles.thumbnailContainer}>
                {data.images.map((img, index) => (
                  <img
                    key={index}
                    src={img.image}
                    alt=""
                    className={
                      selectedImage === img.image ? styles.activeThumb : ""
                    }
                    onClick={() => setSelectedImage(img.image)}
                  />
                ))}
              </div>
            )}
          </div>

          {/* RIGHT SIDE */}

          <div className={styles.productSummary}>
            <div className={styles.summaryTop}>
              <h2>{data.name}</h2>

              <div className={styles.badges}>
                <span className={`${styles.badge} ${styles.available}`}>
                  {data.availability}
                </span>

                {data.isBlocked ? (
                  <span className={`${styles.badge} ${styles.blocked}`}>
                    Blocked
                  </span>
                ) : (
                  <span className={`${styles.badge} ${styles.active}`}>
                    Active
                  </span>
                )}

                {data.isFlagged && (
                  <span className={`${styles.badge} ${styles.flagged}`}>
                    Flagged
                  </span>
                )}
              </div>
            </div>

            <p className={styles.description}>
              {data.about || "No description available."}
            </p>

            {/* ================= QUICK INFO ================= */}

            <div className={styles.quickGrid}>
              <div className={styles.quickCard}>
                <Inventory2OutlinedIcon size={18} />

                <div>
                  <span>Category</span>
                  <strong>{data.categoryName}</strong>
                </div>
              </div>

              <div className={styles.quickCard}>
                <StorefrontOutlinedIcon size={18} />

                <div>
                  <span>Vendor</span>
                  <strong>{data.vendor?.shopName}</strong>
                </div>
              </div>

              <div className={styles.quickCard}>
                <AttachMoneyOutlinedIcon size={18} />

                <div>
                  <span>Base Price</span>
                  <strong>${data.price}</strong>
                </div>
              </div>

              <div className={styles.quickCard}>
                <AccessTimeOutlinedIcon size={18} />

                <div>
                  <span>Available</span>
                  <strong>
                    {data.availabilityStartTime}
                    {" - "}
                    {data.availabilityEndTime}
                  </strong>
                </div>
              </div>
            </div>

            {/* ================= STATUS ================= */}

            <div className={styles.statusCard}>
              <div className={styles.statusItem}>
                <VerifiedUserOutlinedIcon size={18} />

                <div>
                  <span>Marketplace Status</span>

                  <strong>{data.isBlocked ? "Blocked" : "Approved"}</strong>
                </div>
              </div>

              <div className={styles.statusItem}>
                <GppBadOutlinedIcon size={18} />

                <div>
                  <span>Moderation</span>

                  <strong>{data.isFlagged ? "Flagged" : "Clean"}</strong>
                </div>
              </div>

              <div className={styles.statusItem}>
                <CalendarMonthOutlinedIcon size={18} />

                <div>
                  <span>Created</span>

                  <strong>{formatDate(data.createdAt)}</strong>
                </div>
              </div>

              <div className={styles.statusItem}>
                <CalendarMonthOutlinedIcon size={18} />

                <div>
                  <span>Updated</span>

                  <strong>{formatDate(data.updatedAt)}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
        {/* =====================================================
                    PRODUCT INFORMATION
      ===================================================== */}
        <div className={styles.detailsGrid}>
          {/* LEFT COLUMN */}

          <div className={styles.leftColumn}>
            {/* PRODUCT INFO */}

            <div className={styles.detailCard}>
              <h3>Product Information</h3>

              <div className={styles.infoGrid}>
                <div className={styles.infoItem}>
                  <label>Product Name</label>
                  <span>{data.name}</span>
                </div>

                <div className={styles.infoItem}>
                  <label>Category</label>
                  <span>{data.categoryName}</span>
                </div>

                <div className={styles.infoItem}>
                  <label>Sub Category</label>
                  <span>
                    {data.subcategoryName || `#${data.subcategory_id}`}
                  </span>
                </div>

                <div className={styles.infoItem}>
                  <label>Availability</label>
                  <span>{data.availability}</span>
                </div>

                <div className={styles.infoItem}>
                  <label>Available From</label>
                  <span>{data.availabilityStartTime}</span>
                </div>

                <div className={styles.infoItem}>
                  <label>Available Until</label>
                  <span>{data.availabilityEndTime}</span>
                </div>
              </div>

              <div className={styles.descriptionBox}>
                <label>Description</label>

                <p>{data.about || "No description available."}</p>
              </div>
            </div>

            {/* ===================== PRICING ===================== */}

            <div className={styles.detailCard}>
              <h3>Pricing & Variants</h3>

              <div className={styles.priceCard}>
                <div>
                  <label>Base Price</label>

                  <h2>${data.price}</h2>
                </div>
              </div>

              <div className={styles.variantList}>
                {data.variants && data.variants.length > 0 ? (
                  data.variants.map((variant, index) => (
                    <div key={index} className={styles.variantItem}>
                      <div>
                        <strong>{variant.name}</strong>

                        <small>Variant</small>
                      </div>

                      <div className={styles.variantPrice}>
                        ${variant.price}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className={styles.emptyCard}>No Variants Available</div>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN */}

          <div className={styles.rightColumn}>
            {/* ===================== VENDOR ===================== */}

            <div className={styles.detailCard}>
              <h3>Vendor Information</h3>

              <div className={styles.vendorCard}>
                <img
                  src={
                    data.vendor?.shopImage || "/images/store-placeholder.png"
                  }
                  alt=""
                  className={styles.vendorImage}
                  onError={(e) => {
                    e.target.src = "/images/store-placeholder.png";
                  }}
                />

                <div>
                  <h4>{data.vendor?.shopName}</h4>

                  <span>{data.vendor?.fullName}</span>

                  <small>{data.vendor?.email}</small>
                </div>
              </div>

              <div className={styles.vendorInfoGrid}>
                <div className={styles.infoItem}>
                  <label>Vendor ID</label>

                  <span>{data.vendor?.id}</span>
                </div>

                <div className={styles.infoItem}>
                  <label>Shop Name</label>

                  <span>{data.vendor?.shopName}</span>
                </div>
              </div>
            </div>

            {/* ===================== GALLERY ===================== */}

            <div className={styles.detailCard}>
              <div className={styles.galleryHeader}>
                <h3>Product Gallery</h3>

                <span>{data.images?.length || 0} Images</span>
              </div>

              {data.images && data.images.length > 0 ? (
                <div className={styles.galleryGrid}>
                  {data.images.map((image, index) => (
                    <img
                      key={index}
                      src={image.image}
                      alt=""
                      onClick={() => setSelectedImage(image.image)}
                      className={
                        selectedImage === image.image
                          ? styles.activeGalleryImage
                          : styles.galleryImage
                      }
                    />
                  ))}
                </div>
              ) : (
                <div className={styles.emptyGallery}>
                  <ImageOutlinedIcon size={50} />

                  <p>No product images available</p>
                </div>
              )}
            </div>
          </div>
        </div>{" "}
        {/* ======================================================
                    CONTENT MODERATION
      ====================================================== */}
        <div className={styles.detailCard}>
          <div className={styles.cardHeader}>
            <h3>Content Moderation</h3>

            <div className={styles.badgeGroup}>
              {data.isBlocked ? (
                <span className={`${styles.badge} ${styles.badgeRed}`}>
                  Blocked
                </span>
              ) : (
                <span className={`${styles.badge} ${styles.badgeGreen}`}>
                  Active
                </span>
              )}

              {data.isFlagged ? (
                <span className={`${styles.badge} ${styles.badgeOrange}`}>
                  Flagged
                </span>
              ) : (
                <span className={`${styles.badge} ${styles.badgeBlue}`}>
                  Clean
                </span>
              )}
            </div>
          </div>

          <div className={styles.moderationInfo}>
            <div className={styles.infoItem}>
              <label>Current Status</label>

              <span>
                {data.isFlagged
                  ? "This product has already been flagged."
                  : "This product follows marketplace policy."}
              </span>
            </div>

            {data.flagReason && (
              <div className={styles.infoItem}>
                <label>Flag Reason</label>

                <span>{data.flagReason}</span>
              </div>
            )}
          </div>

          <div className={styles.actionButtons}>
            {!data.isFlagged && (
              <button
                className={styles.flagBtn}
                onClick={() => setShowFlagModal(true)}
              >
                <Flag /> Flag Product
              </button>
            )}

            {!data.isRemoved && (
              <button
                className={styles.removeBtn}
                onClick={() => setShowRemoveModal(true)}
              >
                <DeleteForeverOutlinedIcon size={18} />
                Remove Product
              </button>
            )}
          </div>
        </div>
        {/* =====================================
              FLAG PRODUCT MODAL
      ===================================== */}
        {showFlagModal && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <div className={styles.modalHeader}>
                <h2>Flag Product</h2>

                <button onClick={() => setShowFlagModal(false)}>✕</button>
              </div>

              <div className={styles.modalBody}>
                <div className={styles.formGroup}>
                  <label>Violation Reason</label>

                  <select
                    value={flagReason}
                    onChange={(e) => setFlagReason(e.target.value)}
                  >
                    <option value="">Select Reason</option>

                    <option value="Alcohol">Alcohol</option>

                    <option value="Tobacco">Tobacco</option>

                    <option value="Weapons">Weapons</option>

                    <option value="Drugs">Drugs</option>

                    <option value="Adult Content">Adult Content</option>

                    <option value="Counterfeit">Counterfeit</option>

                    <option value="Copyright">Copyright</option>

                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              <div className={styles.modalFooter}>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowFlagModal(false)}
                >
                  Cancel
                </button>

                <button className={styles.flagBtn} onClick={handleFlagProduct}>
                  Flag Product
                </button>
              </div>
            </div>
          </div>
        )}
        {/* =====================================
              REMOVE PRODUCT MODAL
      ===================================== */}
        {showRemoveModal && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <div className={styles.modalHeader}>
                <h2>Remove Product</h2>

                <button onClick={() => setShowRemoveModal(false)}>✕</button>
              </div>

              <div className={styles.modalBody}>
                <p className={styles.warningText}>
                  This action will permanently remove this product from the
                  marketplace.
                </p>

                <div className={styles.formGroup}>
                  <label>Removal Reason</label>

                  <textarea
                    rows={5}
                    placeholder="Enter reason..."
                    value={removeReason}
                    onChange={(e) => setRemoveReason(e.target.value)}
                  />
                </div>
              </div>

              <div className={styles.modalFooter}>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowRemoveModal(false)}
                >
                  Cancel
                </button>

                <button
                  className={styles.removeBtn}
                  onClick={handleRemoveProduct}
                >
                  Remove Product
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ProductDetails;
